import AddCustomerDialog from "./AddCustomerDialog";

export default AddCustomerDialog;
